import * as React from "react"

const _ShirtHoody = ({
  color,
  lightColor
}: {
  color: string
  lightColor: string
  isEditor?: boolean
}) => {
  return (
    <svg
      style={{
        position: "absolute",
        bottom: "-2%",
        width: "98%",
        height: "26%"
      }}
      width="281"
      height="93"
      viewBox="0 0 281 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M182.552 38.4488L182.692 38.4809L182.836 38.4927C228.961 42.2969 256.62 62.7848 276.694 90.9997H3.37453C19.6742 61.6579 42.8579 42.9816 80.4446 34.4117C96.4579 30.7606 115.113 28.9394 137 28.9395C146.456 28.9395 153.814 30.3819 160.796 32.2853C163.383 32.9904 165.983 33.7805 168.643 34.5887C173.045 35.9265 177.611 37.3141 182.552 38.4488Z"
        fill={color}
        stroke="black"
        strokeWidth="4"
      />
      <path
        d="M68.9305 36.5805L78.0837 16.9838C78.3023 16.5157 78.8456 16.293 79.3326 16.4654C117.259 29.8904 151.762 28.945 183.736 20.0444C184.139 19.9324 184.569 20.0806 184.815 20.4178L198.747 39.4703C199.13 39.994 198.935 40.7324 198.331 40.9696C164.724 54.166 101.663 51.9229 69.4152 37.9037C68.9036 37.6813 68.6945 37.0859 68.9305 36.5805Z"
        fill={lightColor}
        stroke="black"
        strokeWidth="4"
      />
    </svg>
  )
}

export const ShirtHoody = React.memo(_ShirtHoody)
